import { useRpcQuery } from "@redotech/redo-web/rpc-query/use-rpc-query";
import { RedoMarketingRpcClientContext } from "../marketing-rpc-client-provider";

export function useIntegrationsByTeam() {
  return useRpcQuery(
    RedoMarketingRpcClientContext,
    "getIntegrationsByTeam",
    {},
  );
}
